import { ComponentProps, ReactNode } from 'react';
import { VariantProps } from 'tailwind-variants';
import { Typography } from '../../molecules/Typography';
import { Icon, iIconProps } from '../Icon';
import { buttonCardClasses } from './variants';

type iButtonCardProps = ComponentProps<'div'> &
  VariantProps<typeof buttonCardClasses> & {
    title: string;
    subtitle?: string | ReactNode;
    icon?: iIconProps;
    orientation?: 'horizontal' | 'vertical';
  };

function ButtonCard({
  title,
  subtitle,
  size = 'sm',
  icon,
  iconPosition = 'left',
  className,
  orientation = 'horizontal',
  ...rest
}: iButtonCardProps) {
  const titleSize = size === 'sm' ? 'h5' : 'h3';
  const subtitleSize = size === 'sm' ? 'small' : 'default';

  return (
    <div
      className={buttonCardClasses({
        iconPosition,
        size,
        className,
        orientation,
      })}
      {...rest}
    >
      {icon && <Icon {...icon} />}
      <div>
        <Typography size={titleSize} type='title'>
          {title}
        </Typography>
        {subtitle && <Typography size={subtitleSize}>{subtitle}</Typography>}
      </div>
    </div>
  );
}

export { ButtonCard };
